import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _19aca378 = () => interopDefault(import('../pages/401/index.vue' /* webpackChunkName: "pages/401/index" */))
const _99f920ec = () => interopDefault(import('../pages/demo/index.vue' /* webpackChunkName: "pages/demo/index" */))
const _2068e508 = () => interopDefault(import('../pages/forbidden/index.vue' /* webpackChunkName: "pages/forbidden/index" */))
const _5b6ccec4 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5c7c4c19 = () => interopDefault(import('../pages/sites/_sid/index.vue' /* webpackChunkName: "pages/sites/_sid/index" */))
const _2eeb8255 = () => interopDefault(import('../pages/preview/_sid/_lang/_pageid/index.vue' /* webpackChunkName: "pages/preview/_sid/_lang/_pageid/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/401",
    component: _19aca378,
    name: "401"
  }, {
    path: "/demo",
    component: _99f920ec,
    name: "demo"
  }, {
    path: "/forbidden",
    component: _2068e508,
    name: "forbidden"
  }, {
    path: "/",
    component: _5b6ccec4,
    name: "index"
  }, {
    path: "/sites/:sid",
    component: _5c7c4c19,
    name: "sites-sid"
  }, {
    path: "/preview/:sid?/:lang?/:pageid",
    component: _2eeb8255,
    name: "preview-sid-lang-pageid"
  }, {
    path: "/:lang/",
    component: _5b6ccec4,
    props: true,
    name: "SiteLangIndexPage"
  }, {
    path: "/:lang/:pageid",
    component: _5b6ccec4,
    props: true,
    name: "SiteLangPagePage"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
